<template>
  <div class="total-commitment-card">
    <el-card class="box-card" style="margin-bottom: 30px;" v-loading="is_loading">
      <div slot="header" class="row d-flex align-items-center">
        <b-col cols="6">
          <h3 class="mb-0">Total Commitment</h3>
        </b-col>
        <b-col>
          <el-button class="float-right py-0 text-primary" type="text" @click="viewDetail()">View Details</el-button>
        </b-col>
      </div>
      <!-- <div v-if="current_customer"> -->
      <div>
        <div class="mb-2">
          <!-- <span class="text-primary total-net-income" v-if="current_customer">RM {{ parseFloat(current_customer.incomes.main.net_income).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span> -->
          <h2 class="text-primary total-commitment">RM {{ parseFloat(total_commitment).toLocaleString(undefined,
            { minimumFractionDigits: 2 }) }}</h2>
          <!-- <b-badge pill variant="dark" class="text-white text-capitalize mx-3" v-if="current_customer.incomes.main.type">{{ current_customer.incomes.main.type }}</b-badge> -->
        </div>
        <p class="top-line">FINTSCORE Report</p>
        <div class="row">
          <div class="col-md-6 my-1" v-if="akpk && akpk.length <= 0">
            <div class="d-flex align-items-center">
              <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
              <span>AKPK</span>
            </div>
          </div>
          <!-- <div class="col-md-6 my-1">
            <div class="d-flex align-items-center">
              <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
              <span>Restructure</span>
            </div>
          </div> -->
          <!-- <div class="col-md-6 my-1">
            <div class="d-flex align-items-center">
              <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
              <span>CTOS Section E</span>
            </div>
          </div> -->
          <div class="col-md-6 my-1" v-if="ssa && ssa.length <= 0">
            <div class="d-flex align-items-center">
              <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
              <span>SSA</span>
            </div>
          </div>
          <div class="col-md-6 my-1" v-if="legal_status && legal_status.length <= 0">
            <div class="d-flex align-items-center">
              <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
              <span>Legal Status Hit</span>
            </div>
          </div>
          <!-- <div class="col-md-6 my-1">
            <div class="d-flex align-items-center">
              <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
              <span>CTOS Section D</span>
            </div>
          </div> -->
        </div>
      </div>
    </el-card>

    <!-- Drawer for Net Income Details -->
    <!-- <drawer-view-net-income-details ref="drawer_net_income"></drawer-view-net-income-details> -->
  </div>
</template>
<script>
import { Card, Button } from 'element-ui'
// import DrawerViewNetIncomeDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/DrawerNetIncome'
import { mapState, mapActions } from 'pinia';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
  name: 'net-income',
  props: ['credit-report'],
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
  },
  data() {
    return {
      customer: {},
      total_commitment: 0,
      commitment: [],
      akpk: [],
      ssa: [],
      legal_status: [],
    }
  },
  computed: {
    ...mapState(useCreditReportStore, ['activeCreditReport']),
		is_loading(){
			return _gHlp.isLoading('fetch_credit_report') || _gHlp.isLoading('fetch_loan_ec') || _gHlp.isLoading('fetch_customer')
		}
  },
  watch: {
    activeCreditReport: {
			handler(newVal) {
				this.commitment = _gHlp.getValue(newVal,'credit_report_summary.commitments',[]);
				this.akpk = _gHlp.getValue(newVal,'credit_report_summary.akpk',[]); 
				this.ssa = _gHlp.getValue(newVal,'credit_report_summary.special_attensions',[]);
				this.legal_status = _gHlp.getValue(newVal,'credit_report_summary.legal_sts',[]); 
			},
    },
    commitment: {
      handler(newVal) {
        this.total_commitment = (!_gHlp.isEmpty(newVal)) ? this.getTotalCommitment() : 0;
      }
    }
  },
  methods: {
		getTotalCommitment() {
      let total = 0
      this.commitment.forEach(item => {
        if (item.commitment_is_manual === 0) {
          item.commitment_sub_items.forEach(sub_item => {
            total += parseFloat(sub_item.commitment_new_installment);
          });
        } else {
          total += parseFloat(item.commitment_new_installment);
        }
      });
      return total;
    },
    viewDetail() {
      this.$emit('change-tab');
    }
  }
}
</script>